import useTranslation from '../../localization/i18n.context';
import SuccessFeedbackScreen from '../../components/shared/SuccessFeedbackScreen/SuccessFeedbackScreen';
import { TrackingEvent } from '../../sdk/tracking.event';
import ErrorFeedbackScreen from '../../components/shared/ErrorFeedbackScreen/ErrorFeedbackScreen';
import Base64 from '../../utils/base64.utils';
import { FailureConfig } from './CompletePageFailureConfig';
import { SuccessConfig } from './CompletePageSuccessConfig';

export const CompleteStyles = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

export const CompleteQueryParams = {
  ORGANIZATION_CODE: 'organizationCode',
  AMOUNT: 'amount',
  TRANSACTION_ID: 'transactionId',
  CREATED_AT: 'createdAt',
};

export default function CompletePage({
  style,
  type,
  params,
  organization: organizationCode,
}) {
  const { t, getOrganization } = useTranslation();

  const getSuccessScreen = () => {
    const decodedString = params ? Base64.decode(params) : '{}';
    const data = SuccessConfig(JSON.parse(decodedString), t, getOrganization)[
      type
    ];

    TrackingEvent.trigger(
      TrackingEvent.Events.COMPLETE_PAGE_SHOW,
      TrackingEvent.Sources.CAAS,
      {
        status: 'success',
        type: type,
      },
    );

    return (
      <>
        {data && (
          <SuccessFeedbackScreen
            onCloseClick={data.onCloseClick}
            image={data.image}
            title={data.title}
            text={data.text}
            subtitle={data.subtitle}
            ctaAction={data.ctaAction}
            ctaText={data.ctaText}
            secondaryCtaText={data.secondaryCtaText}
            secondaryCtaAction={data.secondaryCtaAction}
            icon={data.icon}
            list={data.list}
          />
        )}
      </>
    );
  };

  const getFailureScreen = () => {
    const decodedString = params ? Base64.decode(params) : '{}';
    const data = FailureConfig(JSON.parse(decodedString), t, getOrganization)[
      type
    ];

    TrackingEvent.trigger(
      TrackingEvent.Events.COMPLETE_PAGE_SHOW,
      TrackingEvent.Sources.CAAS,
      {
        status: 'failure',
        type: type,
      },
    );

    return (
      <>
        {data && (
          <ErrorFeedbackScreen
            onCloseClick={data.onCloseClick}
            image={data.image}
            title={data.title}
            text={data.text}
            subtitle={data.subtitle}
            ctaAction={data.ctaAction}
            ctaText={data.ctaText}
            icon={data.icon}
            list={data.list}
          />
        )}
      </>
    );
  };

  return (
    <>
      {style === CompleteStyles.SUCCESS && getSuccessScreen()}
      {style === CompleteStyles.FAILURE && getFailureScreen()}
    </>
  );
}
